import React from "react";
import { Platform } from "react-native";
import { Text } from "@rneui/themed";
import { View } from "../../components/elements";
import { LogInLogOutButton } from "@annunciate/ui/dist/components/buttons/LogInLogOutButton";
import { useUserUUID } from "@annunciate/core";
const NoPurchaseMessage = () => {
    const uuid = useUserUUID();
    return (React.createElement(View, { style: { marginBottom: 20, marginTop: 20, alignItems: "center" } },
        React.createElement(Text, { h2: true, bold: true, style: { marginBottom: 10 } }, "We're Sorry For the Hassle"),
        React.createElement(Text, { style: { textAlign: "center" } }, "To provide the best customer experience, we require all purchases to be made through our website. Please visit our website via a web browser to purchase access."),
        !uuid && (React.createElement(View, { style: { marginTop: 20 } },
            React.createElement(Text, { style: { textAlign: "center" } }, "If you already have access to this content, please log in to your account."),
            React.createElement(LogInLogOutButton, { containerStyle: { paddingTop: 20 }, oidcSignInOnly: Platform.OS === 'ios' })))));
};
export default NoPurchaseMessage;
//# sourceMappingURL=NoPurchaseMessage.js.map